<template>
	<div class="header-wrapper black" v-bind:class="{ 'active' : isMenuActive }">
		<div class="header-nav">
			<h1><router-link :to="{ path: '/' + lang }">Plastic Kills</router-link></h1>
			<div class="menu-trigger">
				<a v-on:click.prevent="isMenuActive = !isMenuActive" href="#"><span></span></a>
			</div>
			<div v-if="isMenuActive" class="lang white">
	      <ul class="ul-horz">
	        <li v-if="lang === 'es'"><a href="#" v-on:click.prevent="lang = 'en'" class="title-font">English</a></li>
	        <li v-if="lang === 'en'"><a href="#" v-on:click.prevent="lang = 'es'" class="title-font">Español</a></li>
	      </ul>
	    </div>
		</div>
		<transition name="fade">
			<div v-show="isMenuActive" class="header-menu-wrapper">
				<div class="span-full span-3 white">
					<div class="item table-wrap">
						<router-link :to="{ name: 'Problems', params: {'lang': lang }}" class="table-cell" @click="hideMenu">
							<div class="item-bg" style="background-image:url('/static/images/menu-bag2.jpg');"></div>
							<h3>{{problems[lang]}}</h3>
						</router-link>
					</div>
					<div class="item table-wrap">
						<router-link :to="{ name: 'Solutions', params: {'lang': lang }}" class="table-cell" @click="hideMenu">
							<div class="item-bg" style="background-image:url('/static/images/menu-bottle2.jpg');"></div>
							<h3>{{solutions[lang]}}</h3>
						</router-link>
					</div>
					<div class="item table-wrap">
						<a v-on:click.prevent="goFooter" href="#" class="table-cell">
							<div class="item-bg" style="background-image:url('/static/images/menu-seal2.jpg');"></div>
							<h3>{{joinUs[lang]}}</h3>
						</a>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>
<script>
	export default {
		name: 'Header',
		data(){
			return {
				lang: localStorage.getItem('language') || 'en',
				isMenuActive: false,
				problems: {
					es: 'Problemas',
					en: 'Problems',
				},
				solutions: {
					es: 'Soluciones',
					en: 'Solutions'
				},
				joinUs: {
					es: 'Participa',
					en: 'Join Us'
				}
			}
		},
		computed: {
			isTriggered(){
				return this.isMenuActive ? 'block' : 'none'
			},
		},
		watch: {
			isMenuActive(){
				document.body.classList.toggle('menu-on')
			},
	    lang(){
	      localStorage.setItem('language', this.lang )
	      this.$router.push({
	        name: this.$route.name,
	        params: {
	          lang: this.lang
	        }
	      })
	    }
		},
		methods: {
			hideMenu(){
				console.log('hiding')
			},
			goFooter(){
				if( document.querySelector('.header-wrapper').classList.contains('active') ){
					document.querySelector('.header-wrapper .menu-trigger a').click()
				}
				setTimeout(()=>{
					window.scrollTo(0,document.body.scrollHeight)
				},10)
			}
		}
	}
</script>


// WEBPACK FOOTER //
// Header.vue?241f9bb2